import { NgModule } from '@angular/core';

import { CdkTableModule } from '@angular/cdk/table';
import { ClipboardModule } from '@angular/cdk/clipboard';

const CdkModuleList = [CdkTableModule, ClipboardModule];

@NgModule({
  imports: CdkModuleList,
  exports: CdkModuleList,
})
export class CdkModule {}
